(() => {
  const fit = hero => {
    hero.querySelectorAll('.ishvarya-hero__content').forEach(content => {
      const title = content.querySelector('.ishvarya-hero__title');
      if (!title || content.clientWidth === 0) return;
      title.style.fontSize = '';
      const maximum = parseFloat(getComputedStyle(title).fontSize);
      const minimum = matchMedia('(max-width:749px)').matches ? 30 : 36;
      let size = maximum;
      while (size > minimum && (title.getBoundingClientRect().height > parseFloat(getComputedStyle(title).lineHeight) * 3.1 || content.scrollHeight > content.clientHeight + 1)) {
        size -= 1;
        title.style.fontSize = `${size}px`;
      }
    });
  };
  const init = () => document.querySelectorAll('.ishvarya-hero').forEach(hero => {
    if (hero.dataset.fitReady) return;
    hero.dataset.fitReady = 'true';
    hero.addEventListener('ishvarya:hero-change', () => fit(hero));
    let frame;
    new ResizeObserver(() => {cancelAnimationFrame(frame);frame = requestAnimationFrame(() => fit(hero));}).observe(hero);
    document.fonts.ready.then(() => fit(hero));
    fit(hero);
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();
